(function() {
    'use strict';

a3_cabin_reports.directive('flightCrew',flightCrew);
    
    
 /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name flightCrew
   * @restrict E
   * @description
   *  Initialize Flight Crew Information
   * @example
   *   Usage:
   *   <flight-crew></flight-crew>
   * @ngInject 
   */      
function flightCrew () {
    function link(scope, element, attrs){
    }
		return {
			restrict: 'E',
			terminal: true,
			templateUrl: "views/directives/flightCrew.tpl.html",
			scope : {
                flight: '='
            },
            link: link
		}
	} 

})();
